<template>
  <div class="subscriptions">
    <v-subscription-create-update-form v-if="this.isShowModal"
                                       :status-list="this.statusList"
                                       @close="closeModal" />
    <div class="row pb-3">
      <div class="col-lg-8">Всего: {{ subscriptionList.count }}</div>
      <div class="col-lg-4 text-center"
           v-if="userData.role === 'administrator' || userData.role === 'employee'">
        <button @click="showModal" class="btn-primary">Добавить подписку</button>
      </div>
    </div>
    <div v-if="this.loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div v-if="userData.role === 'administrator' || userData.role === 'employee'"
             class="col-2">
          <div class="form-group">
            <label for="search-sim">Номер SIM</label>
            <input class="form-control" id="search-sim" v-model="searchSIM"
                      @input="getFilteredSubscriptionList()"
                      @focusin="InputFocusIn('search-sim')"
                      @focusout="InputFocusOut('search-sim')"/>
          </div>
        </div>
        <div v-else-if="userData.role === 'dealer'" class="col-3">
          <div class="form-group">
            <label for="search-phone">Номер подписчика</label>
            <input class="form-control" id="search-phone" v-model="searchPhone"
                      @input="getFilteredSubscriptionList()"
                      @focusin="InputFocusIn('search-phone')"
                      @focusout="InputFocusOut('search-phone')"/>
          </div>
        </div>
        <div v-if="userData.role === 'administrator' || userData.role === 'employee'"
             class="col-2">
          <div class="form-group">
            <label for="search-phone">Номер аб</label>
            <input class="form-control" id="search-phone" v-model="searchPhone"
                      @input="getFilteredSubscriptionList()"
                      @focusin="InputFocusIn('search-phone')"
                      @focusout="InputFocusOut('search-phone')"/>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label for="search-last-name">Фамилия аб</label>
            <input class="form-control" id="search-last-name" v-model="searchLastName"
                      @input="getFilteredSubscriptionList()"
                      @focusin="InputFocusIn('search-last-name')"
                      @focusout="InputFocusOut('search-last-name')"/>
          </div>
        </div>
        <div class="col-3">
          <datepicker v-model="searchCreatedDay" placeholder="Дата создания"
            :language="ru" @input="getFilteredSubscriptionList()"
            input-class="form-control" wrapper-class="form-group"
            :disabled-dates="state.disabledDates" />
        </div>
        <div class="col-3">
          <div class="form-group">
            <multiselect
              v-model="searchDay"
              :options="days"
              track-by="id"
              label="name"
              selectLabel=""
              deselectLabel=""
              @input="getFilteredSubscriptionList()"
              placeholder="День платежа">
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}
              </template>
            </multiselect>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <multiselect
              v-model="searchProvider"
              :options="providerList"
              track-by="id"
              label="name"
              selectLabel=""
              deselectLabel=""
              @input="getFilteredSubscriptionList()"
              placeholder="Оператор">
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}
              </template>
            </multiselect>
          </div>
        </div>
        <div v-if="userData.role === 'administrator' || userData.role === 'employee'"
             class="col-3">
          <div class="form-group">
            <multiselect
              v-model="searchTariff"
              :options="tariffList"
              track-by="id"
              label="name"
              selectLabel=""
              deselectLabel=""
              @input="getFilteredSubscriptionList()"
              placeholder="Выберите тариф">
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}
              </template>
            </multiselect>
          </div>
        </div>
        <div v-if="userData.role === 'administrator' || userData.role === 'employee'"
             class="col-3">
          <div class="form-group">
            <multiselect
              v-model="searchDealer"
              :options="userList"
              selectLabel=""
              deselectLabel=""
              track-by="id"
              label="last_name"
              @input="getFilteredSubscriptionList()"
              placeholder="Выберите дилера">
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.last_name }}
              </template>
            </multiselect>
          </div>
        </div>
        <div class="col-3"
             v-if="userData.role === 'administrator' || userData.role === 'employee'">
          <div class="form-group">
            <multiselect
              v-model="searchStatus"
              :options="statusList"
              track-by="filter"
              label="name"
              selectLabel=""
              deselectLabel=""
              @input="getFilteredSubscriptionList()"
              placeholder="Выберите статус">
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}
              </template>
            </multiselect>
          </div>
        </div>
      </div>

      <div class="row px-3"
           v-if="userData.role === 'administrator' || userData.role === 'employee'">
        <div class="col-3 text-center pb-3">
          <input
            type="checkbox" class="form-check-input"
            @change="getFilteredSubscriptionList()" v-model="onlyAlerted">
          <label class="pl-2 form-check-label">alerted</label>
        </div>
        <div class="col-3 text-center pb-3">
          <input
            type="checkbox" class="form-check-input"
            @change="getFilteredSubscriptionList()" v-model="searchLowBalance">
          <label class="pl-2 form-check-label">low balance</label>
        </div>
        <div class="col-3 text-center pb-3">
          <input
            type="checkbox" class="form-check-input"
            @change="getFilteredSubscriptionList()" v-model="searchWaitPayment">
          <label class="pl-2 form-check-label">wait payment</label>
        </div>
        <div class="col-3  text-center pb-3">
          <input
            type="checkbox" class="form-check-input"
            @change="getFilteredSubscriptionList()" v-model="searchProviderDisabled">
          <label class="pl-2 form-check-label">blocked</label>
        </div>
      </div>

      <!--<div class="row px-3"-->
           <!--v-if="userData.role === 'administrator' || userData.role === 'employee'">-->
        <!--<div class="col-3 text-center border py-1">-->
          <!--<input-->
            <!--type="checkbox" class="form-check-input"-->
            <!--@change="getFilteredSubscriptionList()" v-model="onlyAlerted">-->
          <!--<label class="pl-2 form-check-label">blocked</label>-->
        <!--</div>-->
        <!--<div class="col-3 text-center border py-1">-->
          <!--<input-->
            <!--type="checkbox" class="form-check-input"-->
            <!--@change="getFilteredSubscriptionList()" v-model="searchLowBalance">-->
          <!--<label class="pl-2 form-check-label">low balance</label>-->
        <!--</div>-->
        <!--<div class="col-3 text-center border py-1">-->
          <!--<input-->
            <!--type="checkbox" class="form-check-input"-->
            <!--@change="getFilteredSubscriptionList()" v-model="searchWaitPayment">-->
          <!--<label class="pl-2 form-check-label">wait payment</label>-->
        <!--</div>-->
        <!--<div class="col-3 text-center border py-1">-->
          <!--<input-->
            <!--type="checkbox" class="form-check-input"-->
            <!--@change="getFilteredSubscriptionList()" v-model="searchSuspended">-->
          <!--<label class="pl-2 form-check-label">suspended</label>-->
        <!--</div>-->
      <!--</div>-->

      <v-subscriptions-table :subscription-list="this.subscriptionList.results"
                             :role="userData.role" :status-list="this.statusList"
                             @update="getFilteredSubscriptionList()" />
      <nav class="border pt-3" aria-label="navigation">
        <paginate
          :page-count="this.subscriptionList.total_pages"
          :click-handler="clickCallback"
          :prev-text="'Назад'"
          :next-text="'Вперед'"
          :container-class="'pagination justify-content-center'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'">
        </paginate>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import { ru } from 'vuejs-datepicker/dist/locale';
import VSubscriptionsTable from '../../components/tables/v-subscriptions-table.vue';
import VSubscriptionCreateUpdateForm from
  '../../components/forms/v-subscription-create-update-form.vue';

const state = {
  disabledDates: {
    to: new Date(2020, 0, 0), // Disable all dates up to specific date
    from: new Date(2022, 0, 0), // Disable all dates after specific date
  },
};

export default {
  name: 'Subscriptions',
  components: { Multiselect, VSubscriptionCreateUpdateForm, VSubscriptionsTable },
  data() {
    return {
      ru,
      state,
      onlyAlerted: '',
      searchSIM: '',
      searchPhone: '',
      searchTariff: '',
      searchDealer: '',
      searchProvider: '',
      searchLastName: '',
      searchStatus: '',
      searchDay: '',
      searchCreatedDay: '',
      searchLowBalance: '',
      searchWaitPayment: '',
      searchSuspended: '',
      searchProviderDisabled: '',
      statusList: [
        { filter: 'is_active', name: 'Активна' },
        { filter: 'is_deactivated', name: 'Неактивна' },
        { filter: 'is_paused', name: 'Приостановлена' },
      ],
      isShowModal: false,
      loading: true,
      fullFilter: '',
      page: 1,
      days: [],
    };
  },
  computed: {
    ...mapState('subscription', ['subscriptionList']),
    ...mapState('tariff', ['tariffList']),
    ...mapState('user', ['userList', 'userData']),
    ...mapState('provider', ['providerList']),
  },
  methods: {
    ...mapActions('subscription', ['getSubscriptionList']),
    ...mapActions('tariff', ['getTariffList']),
    ...mapActions('user', ['getUserList']),
    ...mapActions('provider', ['getProviderList']),
    generateDaysDict() {
      Object.keys(Array.from(Array(29).keys())).forEach((key) => {
        this.days.push({
          id: key,
          name: `${key} день месяца`,
        });
      });
      this.days.shift();
    },
    clickCallback(pageNum) {
      this.page = pageNum;
      this.getFilteredSubscriptionList();
    },
    getFilteredSubscriptionList() {
      this.fullFilter = `?page=${this.page}`;
      if (this.searchSIM) {
        this.fullFilter += `&sim_card=${this.searchSIM}`;
      }
      if (this.searchPhone) {
        this.fullFilter += `&subscriber_contact_phone=${this.searchPhone}`;
      }
      if (this.searchLastName) {
        this.fullFilter += `&subscriber_last_name=${this.searchLastName}`;
      }
      if (this.searchDay) {
        this.fullFilter += `&payment_day=${this.searchDay.id}`;
      }
      if (this.searchCreatedDay) {
        this.fullFilter += `&created_at=${this.fixDateToFilter(this.searchCreatedDay)}`;
      }
      if (this.searchTariff) {
        this.fullFilter += `&tariff=${this.searchTariff.id}`;
      }
      if (this.searchDealer) {
        this.fullFilter += `&dealer=${this.searchDealer.id}`;
      }
      if (this.searchProvider) {
        this.fullFilter += `&provider=${this.searchProvider.id}`;
      }
      if (this.searchStatus) {
        this.fullFilter += `&${this.searchStatus.filter}=true`;
      }
      if (this.onlyAlerted) {
        this.fullFilter += '&is_alerted=true';
      }
      if (this.searchLowBalance) {
        this.fullFilter += '&is_low_balance=true';
      }
      if (this.searchWaitPayment) {
        this.fullFilter += '&is_wait_payment=true';
      }
      if (this.searchSuspended) {
        this.fullFilter += '&is_suspended=true';
      }
      if (this.searchProviderDisabled) {
        this.fullFilter += '&is_provider_disabled=true';
      }
      this.getSubscriptionList(this.fullFilter)
        .then(() => { this.loading = false; });
    },
    showModal() {
      this.isShowModal = true;
    },
    closeModal() {
      this.isShowModal = false;
      this.loading = true;
      this.getFilteredSubscriptionList();
    },
  },
  mounted() {
    this.generateDaysDict();
    this.getProviderList('?get_all=true');
    if (this.userData.role === 'administrator' || this.userData.role === 'employee') {
      this.getUserList('?role=dealer&get_all=true');
    }
    this.getTariffList('?get_all=true');
    this.getFilteredSubscriptionList();
  },
};
</script>
